import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Typography, Icon, Card, Breadcrumb, DatePicker, Divider, Table, Calendar } from 'antd';
import { getStaticProRealInfo, getStaticReaInfoByMonth, getStaticRealListByMonth, getStaticReaList, getStaticReaInfo } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import FilterForm from '@/components/form/filterForm';
import './statistical.css';
import { parse } from 'querystring';
import servers from '@/api/server'

const FormItem = Form.Item;
const Option = Select.Option;
const { Text, Title } = Typography;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
let store_cavans, month_cavans, cost_cavans;

const filterItems = [
    {
        name: '月度时间',
        key: 'costYear',
        type: 'yearPicker',
        placeholder: '选择年度'
    }
]



class Statistic_consume extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            reaList: [],
            reaIds: [],
            dataSource: [],
            table_loading: false,
            contextPage: 1,
            contextRows: 5,
            costYear: '',
            pagination: {
                pageSize: 5,
                hideOnSinglePage: true,
            },
            costMothRange: [],
            timeType: 3,
            storeRangeValue: [],
            storeRangeFormat: 'YYYY-mm',
            storeRangeMode: ['month', 'month'],
            storeRangeValue1: null,
            storeRangeValue2: null,
            storeInfo: {},
            costEcharts_flag: true,
            storeRangeOpen: false
        };
        this.getReaList = this.getReaList.bind(this);
        this.monthTableChange = this.monthTableChange.bind(this);
        this.dataFilter = this.dataFilter.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
    }

    componentDidMount() {
        month_cavans = echarts.init(document.getElementById('realMonthCost'));
        month_cavans.showLoading();
        this.getReaList()
        this.reaInfoByMonth({})
        this.getMonthData({});
    }

    //修改state
    onStateChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    }

    // 耗材list
    getReaList() {
        const that = this;
        getStaticReaList({}, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                reaList: res.reaList
            });
        }, err => {
            console.log(err)
        })
    }

    // 获取耗材成本数据
    // getReaCost(params) {
    //     const that = this;
    //     cost_cavans.showLoading()
    //     getStaticProRealInfo(params, res => {
    //         console.log(res);
    //         if (res.statusCode !== 1000) {
    //             return
    //         };
    //         that.setState({
    //             costEcharts_flag: res.per && res.per.length > 0
    //         })
    //         that.realRealCostCanvas(res)
    //     }, err => {
    //         console.log(err)
    //     })
    // }

    // 耗材成本时间范围变化
    // costRangeChange(date, dateString) {
    //     console.log(dateString);
    //     this.getReaCost({
    //         type: 2,
    //         beginTime: dateString[0],
    //         endTime: dateString[1]
    //     });
    // }

    // 获取耗材成本绘制
    // realRealCostCanvas(values) {
    //     const that = this;
    //     cost_cavans.clear();
    //     console.log(values)
    //     let datas = [];
    //     values.reaName.map((x, index) => {
    //         let ret = {};
    //         ret.value = (values.per[index] * 100).toFixed(1);
    //         ret.name = x;
    //         datas.push(ret)
    //     });
    //     cost_cavans.setOption({
    //         title: {
    //             text: '耗材成本占比',
    //             subtext: '耗材成本=耗材领用金额+损耗金额',
    //             x: 'center'
    //         },
    //         tooltip: {
    //             trigger: 'item',
    //             formatter: (params) => {
    //                 return params.seriesName + '<br/>' + params.name + ':' + params.value + '%(￥' + values.money[params.dataIndex] + ')'
    //             }
    //         },
    //         legend: {
    //             // orient: 'vertical',
    //             right: 'center',
    //             bottom: 20,
    //             data: values.reaName,
    //             formatter: function (name) {
    //                 if (name.length > 10) {
    //                     return name.substr(0, 15) + '..'
    //                 }
    //                 return name;
    //             }
    //         },
    //         series: [
    //             {
    //                 name: '耗材成本占比',
    //                 type: 'pie',
    //                 radius: '55%',
    //                 center: ['50%', '50%'],
    //                 data: datas,
    //                 label: {
    //                     formatter: (params) => {
    //                         if (params.name.length > 16) {
    //                             return params.name.substr(0, 15) + '..'
    //                         };
    //                         return params.name;
    //                     }
    //                 },
    //                 itemStyle: {
    //                     emphasis: {
    //                         shadowBlur: 10,
    //                         shadowOffsetX: 0,
    //                         shadowColor: 'rgba(0, 0, 0, 0.5)'
    //                     }
    //                 }
    //             }
    //         ]
    //     });
    //     cost_cavans.on('rendered', function () {
    //         cost_cavans.hideLoading()
    //     });
    // }

    //耗材成本占比表格列表数据获取
    getMonthData(params = {}) {
        const that = this;
        that.setState({
            table_loading: true
        });
        getStaticRealListByMonth(params, res => {
            console.log(res);
            that.setState({
                table_loading: false
            });
            if (res.statusCode !== 1000) {
                return
            };
            const pager = { ...that.state.pagination };
            pager.total = res.count;
            // pager.total = 12;
            that.setState({
                dataSource: res.reaList,
                pagination: pager
            })
        }, err => {
            console.log(err);
            that.setState({
                table_loading: false
            });
        })
    }

    // 删选表格
    dataFilter(values) {
        console.log(values);
        const that = this;
        let params = {
            page: 1,
            rows: that.state.contextRows,
            year: values.costYear ? values.costYear.format('YYYY') : ''
        };
        if (values.costYear) {
            that.setState({
                costYear: values.costYear.format('YYYY')
            });
        };
        const pager = { ...this.state.pagination };
        pager.current = 1;
        that.setState({
            pagination: pager,
        });
        this.getMonthData(params)
    }


    // 耗材成本占比表格分页
    monthTableChange(pagination, filters, sorter) {
        const that = this;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        console.log(sorter)
        this.setState({
            pagination: pager,
        });
        let params = {
            page: pagination.current,
            rows: that.state.contextRows,
            year: that.state.costYear
        };
        this.getMonthData(params)
    }

    // 月耗材成本趋势数据获取
    reaInfoByMonth(params) {
        const that = this;
        month_cavans.showLoading()
        getStaticReaInfoByMonth(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.reaInfoByMonthCanvas(res)
        }, err => {
            console.log(err)
        })
    }

    // 月耗材成本月份区间选择
    costMonthRangeChange = (costMothRange, costMothMmode) => {
        this.setState({
            costMothRange,
        });
        this.reaInfoByMonth({
            beginTime: costMothRange[0].format('YYYYMM'),
            endTime: costMothRange[1].format('YYYYMM')
        })
    }

    // 月耗材成本趋势图形绘制
    reaInfoByMonthCanvas(values) {
        const that = this;
        month_cavans.clear();
        let monthList = [];
        values.month.map(x => {
            let month = x.substr(x.length - 2);
            if (month === '01') {
                monthList.push(x.substr(0, x.length - 2) + '年' + month + '月');
                return
            };
            monthList.push(month + '月')
        });
        console.log(monthList)
        month_cavans.setOption({
            title: {
                text: '月耗材成本情况',
                top: 0,
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                // formatter: '{b}<br/>{a0}: ￥{c0}<br />{a1}: ￥{c1}'
                formatter: (params) => {
                    let tip = '';
                    tip += params[0].axisValue + '<br/>';
                    tip += params[0].marker + '<span>' + params[0].seriesName + ':￥' + params[0].value + '</span><br/>';
                    tip += params[1].marker + '<span>' + params[1].seriesName + ':￥' + params[1].value + '</span>';
                    return tip
                }
            },
            legend: {
                data: ['月总耗材成本趋势', '月损损耗成本趋势'],
                top: 30,
                left: 'center'
            },
            grid: {
                left: '3%',
                right: '12%',
                top: 80,
                bottom: 0,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: monthList,
                axisLabel: {
                    interval: 0
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (value, index) => {
                        console.log(value)
                        return (parseFloat(value) / 10000).toFixed(1) + '万'
                    }
                }
            },
            series: [
                {
                    name: '月总耗材成本趋势',
                    type: 'line',
                    label: {
                        show: true,
                        formatter: '￥{c}'
                    },
                    data: values.reaCost,
                    markLine: {
                        data: [
                            { type: 'average', name: '平均值' }
                        ],
                        label: {
                            formatter: (params) => {
                                return '平均成本:￥' + params.value
                            }
                        }
                    }
                },
                {
                    name: '月损损耗成本趋势',
                    type: 'line',
                    label: {
                        show: true
                    },
                    data: values.lossCost,
                    markLine: {
                        data: [
                            { type: 'average', name: '平均值' }
                        ],
                        label: {
                            formatter: (params) => {
                                return '平均成本:￥' + params.value
                            }
                        }
                    }
                }
            ]
        });
        month_cavans.on('rendered', function () {
            month_cavans.hideLoading()
        });
    }

    render() {
        const that = this;
        const { costEcharts_flag, storeRangeOpen, reaList, reaIds, costMothRange, storeRangeMode, storeRangeValue, storeRangeFormat, timeType, storeRangeValue1, storeRangeValue2, storeInfo } = this.state;
        let storeLiStyle = {
            width: storeInfo.time ? 83 / storeInfo.time.length + '%' : '83%'
        }
        return (
            <div className="statistic">
                <Card
                    title={
                        <div className="pr">
                            <Text strong style={{ fontSize: '15px' }}><i className="iconfont icon-shujutu c_8bff mr5 vm"></i>月耗材成本趋势</Text>
                            <RangePicker
                                format="YYYY-MM"
                                mode={['month', 'month']}
                                style={{ width: '212px' }}
                                onPanelChange={(value, mode) => this.costMonthRangeChange(value, mode)}
                                value={costMothRange}
                                className="pa_rm"
                            />
                        </div>
                    }
                    className="statistic_panel"
                >
                    <div className="statistic_pro_tabPane" id="realMonthCost"></div>
                </Card>
            </div>
        )
    }
}


export default Statistic_consume;

